import React, { useRef, useState } from 'react';
import { useTheme } from '@mui/material';
import { Box, ClickAwayListener, Paper } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tooltip, TooltipPlacement } from '../../../../display/tooltip';
import { useTableContext } from '../../context';
import { StyledIconButton } from '../styled';
import { QuickFilterPanel } from './quick-filter-panel';

export interface FilterButtonProps {
  isFilterActive?: boolean;
  onFilterToggle?: () => void;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  isFilterActive = false,
  onFilterToggle,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  useTableContext<Record<string, unknown>>();

  const handleToggle = () => {
    setOpen((prev) => !prev);
    onFilterToggle?.();
  };

  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ position: 'relative' }}>
      <Tooltip
        title={isFilterActive ? 'Clear filters' : 'Filter data'}
        placement={TooltipPlacement.Top}
      >
        <StyledIconButton ref={anchorRef} onClick={handleToggle}>
          <SystemIcon
            iconName={isFilterActive ? 'FunnelSimpleX' : 'FunnelSimple'}
            style={{
              color: theme.palette.text.main,
              fontSize: '18px',
            }}
          />
        </StyledIconButton>
      </Tooltip>

      {open && (
        <ClickAwayListener
          onClickAway={(e) => {
            const target = e.target as HTMLElement;
            if (
              target.closest('.quick-filter-panel-root') ||
              target.closest('[data-keepopen="1"]')
            ) {
              return;
            }
            handleClose();
          }}
        >
          <Paper
            elevation={6}
            sx={{
              position: 'absolute',
              top: '100%',
              right: 0,
              mt: 1,
              zIndex: 1000,
            }}
          >
            <Box className="quick-filter-panel-root">
              <QuickFilterPanel onClose={handleClose} />
            </Box>
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
};
